var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgThreeDotsVertical = function SvgThreeDotsVertical(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.49691e-07 8.5C-3.97973e-07 9.60457 0.89543 10.5 2 10.5C3.10457 10.5 4 9.60457 4 8.5C4 7.39543 3.10457 6.5 2 6.5C0.89543 6.5 -3.01409e-07 7.39543 -3.49691e-07 8.5Z",
    fill: "#A4A5AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.74228e-08 2.5C-1.35705e-07 3.60457 0.89543 4.5 2 4.5C3.10457 4.5 4 3.60457 4 2.5C4 1.39543 3.10457 0.5 2 0.5C0.895431 0.5 -3.91405e-08 1.39543 -8.74228e-08 2.5Z",
    fill: "#A4A5AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.11959e-07 14.5C-6.60242e-07 15.6046 0.89543 16.5 2 16.5C3.10457 16.5 4 15.6046 4 14.5C4 13.3954 3.10457 12.5 2 12.5C0.89543 12.5 -5.63677e-07 13.3954 -6.11959e-07 14.5Z",
    fill: "#A4A5AA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDotsVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "three-dots-vertical.46fd89a187977a4e8dc13cca66639ec9.svg";